import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { AddGroup } from "./addGroup";
import { EditGroup } from "./editGroup";
import { GroupsList } from "./groupsList";
import { GroupDetail } from "./groupDetail";



const Groups = memo(() => {
  return (
    <Routes>
      <Route path={routesName.ADDGROUP} element={<AddGroup />} />
      <Route path={routesName.EDITGROUP} element={<EditGroup />} />
      <Route path={routesName.GROUPDETAIL} element={<GroupDetail />} />
      <Route path={routesName.GROUPSLIST} element={<GroupsList />} />
    </Routes>
  );
});

export { Groups };
